<template>
    <div class="flex flex-col gap-6 ">
        <div v-if="donationSuccess" class="rounded-md bg-green-200 mb-10 ">
            <div class="mx-auto max-w-7xl px-4  sm:px-6 lg:px-8">
                <div class="flex p-4 ">
                    <div class="flex-shrink-0">
                        <svg class="h-5 w-5 text-green-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd"
                                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                                clip-rule="evenodd" />
                        </svg>
                    </div>
                    <div class="ml-3">
                        <h3 class="text-sm font-medium text-green-800">Payment successful! </h3>
                        <div class="mt-2 text-sm text-green-700">
                            <p> Your payment has been completed successfully.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="top"
            class="flex-col flex gap-4 py-10 px-4 sm:px-6 lg:px-8 max-w-5xl shadow-lg rounded-lg bg-white border border-gray-200">
            <div class=" flex-col flex gap-6">
                <div class="flex justify-end flex-col gap-2 sm:gap-6 sm:flex-row  -mt-4">

                    <!-- <a href="/protest-requests/final-outcome/download-final-order"
                        class="cursor-pointer  inline-flex items-center justify-center px-3 py-3 rounded-md text-xs font-medium bg-indigo-600 text-white leading-6 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                        <i class="fa fa-download mr-1.5 text-sm leading-6"></i>
                        <template v-if="userPropertiesCount == 1">
                            Download Official Protest Results
                        </template>
                        <template v-else>
                            Access dashboard to download official protest results
                        </template>
                    </a> -->
                    <a href="javascript::void(0)" @click="goToDonate"
                        class=" gap-1   lg:w-auto   bg-green-400 border border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 font-medium hover:bg-green-500 items-center justify-center md:px-4  py-2 px-1 rounded-md shadow-sm  text-white text-xs  flex flex-col item-center tracking-wide">
                        <div class="flex flex-row">
                            <svg class="w-4 h-4 mr-1" width="24" height="24" viewBox="0 0 30 30" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M14.9998 14.351C11.0431 14.351 7.82422 11.1322 7.82422 7.17551C7.82422 3.21885 11.0431 0 14.9998 0C18.9563 0 22.1753 3.21896 22.1753 7.17557C22.1753 11.1322 18.9564 14.351 14.9998 14.351ZM14.9998 1.65639C11.9565 1.65639 9.48061 4.13227 9.48061 7.17557C9.48061 10.2188 11.9565 12.6947 14.9998 12.6947C18.0431 12.6947 20.5189 10.2188 20.5189 7.17557C20.5189 4.13232 18.0431 1.65639 14.9998 1.65639Z"
                                    fill="white" />
                                <path
                                    d="M14.7393 10.5738C13.6002 10.5358 12.6699 9.94725 12.6699 9.33975C12.6699 9.01701 12.9547 8.54234 13.3154 8.54234C13.7141 8.54234 14.0369 9.10244 14.7393 9.22584V7.68793C13.866 7.35565 12.8408 6.94754 12.8408 5.73236C12.8408 4.52674 13.7331 3.94777 14.7393 3.80539V3.53955C14.7393 3.4066 14.8912 3.2832 15.1 3.2832C15.2804 3.2832 15.4608 3.4066 15.4608 3.53955V3.77686C16.0493 3.79584 17.16 3.94771 17.16 4.60273C17.16 4.85908 16.9892 5.38115 16.5715 5.38115C16.2582 5.38115 16.0779 5.07734 15.4609 5.02994V6.41586C16.3247 6.73859 17.331 7.18479 17.331 8.46629C17.331 9.64338 16.5716 10.3554 15.4609 10.5357V10.811C15.4609 10.9439 15.2805 11.0673 15.1002 11.0673C14.8913 11.0673 14.7395 10.9439 14.7395 10.811V10.5737H14.7393V10.5738ZM14.8343 6.18816V5.05848C14.4071 5.14396 14.2267 5.36229 14.2267 5.5901C14.2268 5.86537 14.4736 6.03623 14.8343 6.18816ZM15.3659 7.94434V9.21635C15.6886 9.14041 15.945 8.96 15.945 8.61828C15.9449 8.30504 15.7076 8.10564 15.3659 7.94434Z"
                                    fill="white" />
                                <path
                                    d="M23.308 29.9999H6.69131C4.92031 29.9999 3.47949 28.5591 3.47949 26.7881V16.8746C3.47949 16.4173 3.85027 16.0464 4.30771 16.0464C4.76516 16.0464 5.13594 16.4172 5.13594 16.8746V26.7881C5.13594 27.6457 5.83367 28.3435 6.69137 28.3435H23.3081C24.1658 28.3435 24.8635 27.6458 24.8635 26.7881V21.3034C24.8635 20.8461 25.2343 20.4752 25.6917 20.4752C26.1492 20.4752 26.52 20.846 26.52 21.3034V26.7881C26.5198 28.5591 25.079 29.9999 23.308 29.9999Z"
                                    fill="white" />
                                <path
                                    d="M25.291 17.7027H4.70879C3.05199 17.7027 1.7041 16.3548 1.7041 14.698C1.7041 13.0412 3.05199 11.6934 4.70879 11.6934H6.13643C6.59387 11.6934 6.96465 12.0642 6.96465 12.5216C6.96465 12.9789 6.59387 13.3498 6.13643 13.3498H4.70879C3.96529 13.3498 3.36049 13.9547 3.36049 14.6981C3.36049 15.4415 3.96529 16.0464 4.70879 16.0464H25.291C26.0345 16.0464 26.6393 15.4415 26.6393 14.6981C26.6393 13.9547 26.0345 13.3498 25.291 13.3498H23.8634C23.4059 13.3498 23.0352 12.979 23.0352 12.5216C23.0352 12.0643 23.4059 11.6934 23.8634 11.6934H25.291C26.9478 11.6934 28.2957 13.0412 28.2957 14.698C28.2957 16.3548 26.9478 17.7027 25.291 17.7027Z"
                                    fill="white" />
                            </svg>
                            Support the Mission
                        </div>
                        <i class="text-center leading-3" style="font-size:9px"> Donate to Pay it Forward so we can help
                            More
                            People</i>
                    </a>
                </div>
                <div class="flex-col flex gap-6">
                    <div>
                        <p class="text-lg sm:text-xl font-bold text-gray-800 mb-2 sm:mb-0">Provide feedback or scroll down
                            for FAQs
                        </p>
                    </div>

                    <template v-if="errorMessage">
                        <div class="rounded-md bg-red-50 mb-10 ">
                            <div class="mx-auto max-w-7xl">
                                <div class="flex p-4 ">
                                    <div class="flex-shrink-0">
                                        <svg class="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z" clip-rule="evenodd" />
                                        </svg>
                                    </div>
                                    <div class="ml-3">
                                        <div class="text-sm text-red-700">
                                            <p> {{ errorMessage }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>


                    <template v-if="!message">
                        <template v-if="savingFeedback">
                            <div class="flex justify-center">
                                <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-gray-400"
                                    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                        stroke-width="4">
                                    </circle>
                                    <path class="opacity-75" fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                    </path>
                                </svg>
                            </div>
                        </template>
                        <template v-else>
                            <div class=" mb-4">
                                <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
                                    <div class="overflow-auto">
                                        <table class="min-w-full divide-y divide-gray-300">
                                            <thead class="bg-gray-50">
                                                <tr class="divide-x divide-gray-300">
                                                    <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-6">
                                                        <span class="sr-only">Edit</span>
                                                    </th>
                                                    <th scope="col"
                                                        class="py-3.5 pl-4 pr-3  text-sm font-semibold text-gray-900 sm:pl-6  text-center">
                                                        <p class="flex flex-row  items-center gap-1">
                                                            <span v-html="svg.veryHappySvg"></span>
                                                            Very happy
                                                        </p>

                                                    </th>
                                                    <th scope="col"
                                                        class="px-3 py-3.5 text-center text-sm font-semibold text-gray-900 inline-flex gap-1 items-center">
                                                        <p class="flex flex-row gap-1 items-center">

                                                            <span v-html="svg.mildlyHappySvg"></span>
                                                            Mildly happy
                                                        </p>

                                                    </th>
                                                    <th scope="col"
                                                        class="px-3 py-3.5 text-center text-sm font-semibold text-gray-900 ">
                                                        <p class="flex flex-row gap-1 items-center">

                                                            {{ svg.mildlyUnhappy }}
                                                            <span v-html="svg.mildlyUnhappySvg"></span>
                                                            Mildly unhappy
                                                        </p>

                                                    </th>
                                                    <th scope="col"
                                                        class="px-3 py-3.5 text-center text-sm font-semibold text-gray-900 ">
                                                        <p class="flex flex-row gap-1 items-center">

                                                            <span v-html="svg.veryUnhappySvg"></span>
                                                            Very unhappy
                                                        </p>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody class="divide-y divide-gray-200 bg-white">
                                                <tr class="divide-x divide-gray-300">
                                                    <td
                                                        class="whitespace-nowrap py-4 pl-4 pr-3 text-sm  font-medium text-gray-900 sm:pl-6">
                                                        Reduction amount
                                                    </td>
                                                    <td
                                                        class="whitespace-nowrap px-3 py-4 text-sm  text-center text-gray-500">
                                                        <input name="reduction_amount" v-model="reductionAmount"
                                                            type="radio" value="1" class="cursor-pointer" required>
                                                    </td>
                                                    <td
                                                        class="whitespace-nowrap px-3 py-4 text-sm text-center  text-gray-500">
                                                        <input name="reduction_amount" v-model="reductionAmount"
                                                            type="radio" value="2" class="cursor-pointer">
                                                    </td>
                                                    <td
                                                        class="whitespace-nowrap px-3 py-4 text-sm text-center text-gray-500">
                                                        <input name="reduction_amount" v-model="reductionAmount"
                                                            type="radio" value="3" class="cursor-pointer">
                                                    </td>
                                                    <td
                                                        class="whitespace-nowrap px-3 py-4 text-center text-sm text-gray-500">
                                                        <input name="reduction_amount" v-model="reductionAmount"
                                                            type="radio" value="4" class="cursor-pointer">
                                                    </td>
                                                </tr>
                                                <tr class="divide-x divide-gray-300">
                                                    <td
                                                        class="whitespace-nowrap py-4  pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                                        The service we provide</td>
                                                    <td
                                                        class="whitespace-nowrap px-3 py-4  text-center text-sm text-gray-500">
                                                        <input name="service_we_provide" v-model="serviceWeProvide"
                                                            type="radio" value="1" class="cursor-pointer" required>
                                                    </td>
                                                    <td
                                                        class="whitespace-nowrap px-3 py-4 text-center text-sm text-gray-500">
                                                        <input name="service_we_provide" v-model="serviceWeProvide"
                                                            type="radio" value="2" class="cursor-pointer">
                                                    </td>
                                                    <td
                                                        class="whitespace-nowrap px-3 py-4 text-center text-sm text-gray-500">
                                                        <input name="service_we_provide" v-model="serviceWeProvide"
                                                            type="radio" value="3" class="cursor-pointer">
                                                    </td>
                                                    <td
                                                        class="whitespace-nowrap px-3 py-4 text-center text-sm text-gray-500">
                                                        <input name="service_we_provide" v-model="serviceWeProvide"
                                                            type="radio" value="4" class="cursor-pointer">
                                                    </td>
                                                </tr>
                                                <tr class="divide-x divide-gray-300">
                                                    <td
                                                        class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                                        The property tax system in general
                                                    </td>
                                                    <td
                                                        class="whitespace-nowrap px-3 text-center py-4 text-sm text-gray-500">
                                                        <input name="property_tax_system" v-model="propertyTaxSystem"
                                                            type="radio" value="1" class="cursor-pointer" required>
                                                    </td>
                                                    <td
                                                        class="whitespace-nowrap text-center px-3 py-4 text-sm text-gray-500">
                                                        <input name="property_tax_system" v-model="propertyTaxSystem"
                                                            type="radio" value="2" class="cursor-pointer">
                                                    </td>
                                                    <td
                                                        class="whitespace-nowrap px-3 text-center py-4 text-sm text-gray-500">
                                                        <input name="property_tax_system" v-model="propertyTaxSystem"
                                                            type="radio" value="3" class="cursor-pointer">
                                                    </td>
                                                    <td
                                                        class="whitespace-nowrap text-center px-3 py-4 text-sm text-gray-500">
                                                        <input name="property_tax_system" v-model="propertyTaxSystem"
                                                            type="radio" value="4" class="cursor-pointer">
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="">
                                <label for="comment" class="block text-sm font-medium leading-6 text-gray-700">Comments /
                                    Questions</label>
                                <div class="mt-2">
                                    <textarea rows="4" v-model="feedbackMessage" id="feedback_form"
                                        placeholder="Write a Feedback.."
                                        class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"></textarea>
                                </div>
                                <div class="mt-1">
                                    <input name="contact_user" v-model="contactUser" type="checkbox" value="1"
                                        class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600 cursor-pointer"><span
                                        class=" ml-2 text-sm font-medium leading-6 text-gray-700">Check this box if you
                                        would
                                        like
                                        us to
                                        contact you</span>
                                </div>
                            </div>
                            <!-- <div class="border-b border-gray-200 w-full"></div> -->
                            <div class="flex justify-end mb-2">
                                <button @click="submitFeedBackForm" type="button"
                                    class="rounded-md bg-indigo-600 px-2.5 sm:px-6 py-1.5 text-sm font-medium text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Submit</button>
                            </div>
                        </template>

                    </template>
                    <template v-else>
                        <div v-if="message" class="rounded-md bg-green-200 mb-10 ">
                            <div class="mx-auto max-w-7xl">
                                <div class="flex p-4 ">
                                    <div class="flex-shrink-0">
                                        <svg class="h-5 w-5 text-green-400" viewBox="0 0 20 20" fill="currentColor"
                                            aria-hidden="true">
                                            <path fill-rule="evenodd"
                                                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                                                clip-rule="evenodd" />
                                        </svg>
                                    </div>
                                    <div class="ml-3">
                                        <div class="text-sm text-green-700">
                                            <p> {{ message }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>

                </div>
            </div>

            <hr>
            <div v-if="false">
                <div id="" class="flex justify-center cursor-default">
                    <h1 class="text-2xl font-bold leading-10 text-center my-6  tracking-tight text-gray-900">Frequently Asked
                        Questions &amp; Contact Us</h1>
                </div>
                
                <frequently-asked-questions></frequently-asked-questions>
            </div>
        </div>
    </div>
</template>

<script>
import ProtestRequestApi from "@/services/api/ProtestRequest.js";
import { apiUrl } from "../../../../config/base.js";
import FrequentlyAskedQuestions from "../FinalOutcome/FrequentlyAskeduestions.vue"

export default {
    props: ['user', 'svg', 'donation-success', 'user-properties-count'],
    data() {
        return {
            reductionAmount: null,
            propertyTaxSystem: null,
            serviceWeProvide: null,
            contactUser: null,
            feedbackMessage: null,
            message: null,
            savingFeedback: false,
            errorMessage: null,
        }
    },
    components: {
        FrequentlyAskedQuestions,
    },
    created() {

    },
    methods: {
        goToDonate(data) {
            window.location.href = apiUrl + '/protest-requests/final-outcome/show-donation-page';
        },

        submitFeedBackForm(data) {


            var payload = {
                'reductionAmount': this.reductionAmount,
                'propertyTaxSystem': this.propertyTaxSystem,
                'serviceWeProvide': this.serviceWeProvide,
                'contactUser': this.contactUser,
                'feedbackMessage': this.feedbackMessage
            };

            this.savingFeedback = true;
            ProtestRequestApi.storeFeedbackFormData(payload).then((response) => {
                this.savingFeedback = false;
                console.log(response.data);
                if (response.data.error == false) {
                    this.message = response.data.message;
                    // window.location.href = apiUrl + '/protest-requests/final-outcome/show-feedback-form';
                }

                if(response.data.error){
                    this.errorMessage = response.data.message;
                    setTimeout(() => {
                        window.location.href = apiUrl+'/properties';
                    }, 3000);
                }
            }).catch((error) => {
                window.flash("Error: " + error, "error");
            });
        }
    }
}
</script>
